import { render, staticRenderFns } from "./GuideCategories.vue?vue&type=template&id=a31df9d6&"
import script from "./GuideCategories.vue?vue&type=script&lang=js&"
export * from "./GuideCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports